import * as React from 'react';
import ChannelsAutocomplete from '../ChannelsAutocomplete';
import { ChannelSelectionProps } from '../../../../../../../slices/orders/channelsSlice';
import { Moment } from 'moment';
import { User } from '../../../../../../../components/Autocomplete/Users/model';

import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Icon,
  Stack,
  Divider,
} from '@mui/material';
import LoaderThreeDots from '../../../../../../../components/LoaderThreeDots';

const ExistingPeriods = React.lazy(() => import('./ExistingPeriods'));
export interface PeriodProps {
  id: number;
  startTime: Moment | null;
  endTime: Moment | null;
  intervalThreshold: number;
  userRoleIdAllowed?: string | null;
  exceptionUsers?: string | null;
  emails: User[] | undefined;
}

export default function PeriodSettings() {
  const [open, setOpen] = React.useState(false);
  const [channel, setChannel] = React.useState<ChannelSelectionProps[] | undefined>([]);

  React.useEffect(() => {
    if (open) {
      setChannel([]);
    }
  }, [open]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChannelChange = (newValue: ChannelSelectionProps[] | null) => {
    if (!newValue) {
      setChannel([]);
      return;
    }

    if (newValue.length > 1) newValue?.shift();
    setChannel(newValue);
  };

  return (
    <>
      <ListItemButton onClick={handleClickOpen}>
        <ListItemIcon>
          <Icon>schedule</Icon>
        </ListItemIcon>
        <ListItemText primary="Settings" />
      </ListItemButton>
      <Dialog
        open={open}
        onClose={(_, reason: string) => {
          if (reason === 'backdropClick') return;
          handleClose();
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Periods
          <IconButton sx={{ position: 'absolute', top: 8, right: 8 }} onClick={handleClose}>
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText>
              To receive alerts when system is not receiving any orders: <br />- Select a channel to
              start editing.
              <br />- Select a period (i.e: 8:00 AM - 5:00PM), then select the time gap (in
              minutes).
              <br />
              - Ensure all periods cover a full-24-hour-period.
              <br />- Email alert is optional, you can opt out at any time.
              <br />- Users have the option to apply changes to all other channels.
            </DialogContentText>
            <Divider />
            <ChannelsAutocomplete
              value={channel}
              handleValueChange={handleChannelChange}
              label="Select a channel to make changes"
            />
            <React.Suspense fallback={<LoaderThreeDots title="Loading..." />}>
              <ExistingPeriods channelId={channel && channel[0]?.id} />
            </React.Suspense>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
